import { type FC } from 'react';

import { _notNil } from '@/littledash';
import type { Study } from '@/model/Study.model';

import type { SuccessfulOverviewSection } from '../../OverviewAccordion.model';
import { canEditOverviewTreatment } from '../../overviewSectionAccess';
import EditableOverviewTreatmentsTable from '../OverviewTreatmentsTable/EditableOverviewTreatmentsTable';
import OverviewTreatmentsTable from '../OverviewTreatmentsTable/OverviewTreatmentsTable';

interface TreatmentsSectionContentProps {
  section: SuccessfulOverviewSection<'treatments' | 'diseases'>;
  study?: Study;
  studyId?: string;
  diseaseInduction?: boolean;
}

const SECTION_CLASSIFICATIONS = {
  treatments: 'treatment',
  diseases: 'disease_induction',
} as const;

/**
 * Renders Overview treatments or diseases with the same read columns as the matching
 * study-groups tab, and the groups-table treatment info modal behind the label when the caller can open it.
 */
const TreatmentsSectionContent: FC<TreatmentsSectionContentProps> = ({
  section,
  study,
  studyId,
  diseaseInduction = false,
}) => {
  const classification = SECTION_CLASSIFICATIONS[section.type];

  return (
    <div data-test-component="TreatmentsSectionContent" data-test-element="container">
      {canEditOverviewTreatment(study, classification, diseaseInduction) && _notNil(study) ? (
        <EditableOverviewTreatmentsTable rows={section.rows} study={study} type={classification} />
      ) : (
        <OverviewTreatmentsTable
          rows={section.rows}
          type={classification}
          studyId={studyId ?? (_notNil(study) ? String(study.id) : undefined)}
        />
      )}
    </div>
  );
};

export default TreatmentsSectionContent;
